import React from "react";
import { inlineStyles, blockTypes } from "./constants";
import styled from "styled-components";
import { ToolbarItem, Container } from "./common";
import { RichUtils } from "draft-js";

export function RenderInlineStyles(props) {
  const { editorState, updateEditorState } = props;
  const applyStyle = (e, style) => {
    e.preventDefault();
    updateEditorState(RichUtils.toggleInlineStyle(editorState, style));
  };

  const isActive = style => {
    const currentStyle = editorState.getCurrentInlineStyle();
    return currentStyle.has(style);
  };

  const applyBlockStyle = (e, style) => {
    e.preventDefault();
    updateEditorState(RichUtils.toggleBlockType(editorState, style));
  }

  // const isBlockActive = style => {
  //   const blockType = editorState.getCurrentContent()
  //   const blockStyle = blockType.getType();
  //   return blockStyle.has(style)
  // }

  return (
    <Container>
      {inlineStyles.map((item, idx) => {
        return (
          <ToolbarItem
            isActive={isActive(item.style)}
            key={`${item.label}-${idx}`}
            onMouseDown={e => applyStyle(e, item.style)}
          >
            {item.icon || item.label}
          </ToolbarItem>
        );
      })}

      {blockTypes.map((item, idx) => {
        return (
          <ToolbarItem
            key={`${item.label}-${idx}`}
            onMouseDown={e => applyBlockStyle(e, item.style)}
          >
            {item.icon || item.label}
          </ToolbarItem>
        )
      })}
    </Container>
  );
}
